import { AppName } from 'signup-ui-lego-core/constants/AppName';
import { DefaultFlowOptions } from '../flow-initial/FlowOptions';
import { Microapp } from 'signup-constants/Microapp';
import { getMicroappKey } from '../routing/getMicroappKey';
import { isMicroappValid } from 'signup-ui-lego-core/utils/isMicroappValid';
import { SignupApiFlowPath } from '../http-clients/SignupApiFlowPath';
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
import { getIsNewUser } from '../store/app/selectors';
import { isEndpointStatusSuccess } from '../store/http-responses/selectors';
import { EndpointKey } from '../http/EndpointKey';
import { getQueryParam } from '../routing/getQueryParam';
import { checkEmailSignatureRedirect } from '../signup-completed-redirection/checkEmailSignatureRedirect';
export const defaultMicroappFlowOptions = Object.assign({}, DefaultFlowOptions, {
  appName: AppName.Microapp,
  showMobileAppPrompt: false,
  signupApiFlowPath: SignupApiFlowPath.Microapp
});
const FlowOptionsByMicroapp = {
  [Microapp.CampaignAssistant]: Object.assign({}, defaultMicroappFlowOptions, {
    shouldHalveProgressBar: true
  }),
  [Microapp.GuideCreator]: defaultMicroappFlowOptions,
  [Microapp.ClipCreator]: Object.assign({}, defaultMicroappFlowOptions, {
    shouldHalveProgressBar: true
  }),
  [Microapp.EmailSignatureGenerator]: Object.assign({}, defaultMicroappFlowOptions, {
    canRedirect: state => {
      return getQueryParam('external-experiment-parameter') === 'dist-0030-group-variant_a' ? checkEmailSignatureRedirect(state) : true;
    }
  }),
  [Microapp.BrandKitGenerator]: defaultMicroappFlowOptions,
  [Microapp.BlogIdeasGenerator]: Object.assign({}, defaultMicroappFlowOptions, {
    canRedirect: state => {
      return getIsNewUser(state) ? isEndpointStatusSuccess(EndpointKey.CheckScopesForBlogIdeasGeneratorNewUser)(state) : true;
    }
  }),
  [Microapp.LandingPageCreator]: defaultMicroappFlowOptions,
  [Microapp.WebsiteGrader]: Object.assign({}, defaultMicroappFlowOptions, {
    isOptionalDomainEnabled: true,
    hubInterest: HubInterestOption.CMS
  }),
  [Microapp.InvoiceGenerator]: defaultMicroappFlowOptions
};
export const getMicroappFlowOptions = () => {
  const microappKey = getMicroappKey();
  if (!microappKey || !isMicroappValid(microappKey)) {
    return defaultMicroappFlowOptions;
  }
  return FlowOptionsByMicroapp[microappKey];
};